import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { queryWaitMeApplys, saveFlowTrack, getFormCate } from '@/services/form';
var columns = [{
  title: '申请流水号',
  dataIndex: 'fillId',
  align: 'center',
  width: 20
}, {
  title: '标题',
  dataIndex: 'formName',
  ellipsis: true,
  align: 'center',
  resizable: true,
  width: 30,
  scopedSlots: {
    customRender: 'dbFormName'
  }
}, {
  title: '',
  dataIndex: '',
  ellipsis: true,
  align: 'center',
  resizable: true,
  width: 5,
  scopedSlots: {
    customRender: 'formName'
  }
}, {
  title: '类型',
  dataIndex: 'category',
  ellipsis: true,
  align: 'center',
  width: 15
}, {
  title: '申请人',
  dataIndex: 'startUserName',
  ellipsis: true,
  align: 'center',
  resizable: true,
  width: 30
}, {
  title: '申请时间',
  dataIndex: 'startTime',
  ellipsis: true,
  align: 'center',
  width: 30
}, {
  title: '当前审批节点',
  dataIndex: 'taskName',
  ellipsis: true,
  align: 'center',
  width: 20
}, {
  title: '接收时间',
  dataIndex: 'createTime',
  ellipsis: true,
  align: 'center',
  width: 30
}, {
  title: '办理状态',
  dataIndex: 'status',
  align: 'center',
  width: 15,
  scopedSlots: {
    customRender: 'status'
  }
}, {
  title: '概述',
  dataIndex: 'summary',
  width: 20
}, {
  title: '操作',
  dataIndex: '',
  align: 'center',
  width: 20,
  scopedSlots: {
    customRender: 'action'
  }
}];
// const columns = [
//     {
//         title: '表单名称',
//         dataIndex: 'formName',
//         width: 200,
//         key: 'formName'
//     },
//     // {
//     //   title: '流水号',
//     //   dataIndex: 'description',
//     //   scopedSlots: { customRender: 'description' }
//     // },
//     {
//         title: '发起时间',
//         dataIndex: 'createTime',
//         key: 'createTime',
//         width: 120
//     },
//     {
//         title: '当前节点',
//         dataIndex: 'taskName',
//         key: 'taskName',
//         width: 70
//     },
//     // {
//     //   title: '状态',
//     //   dataIndex: 'updatedAt2',
//     //   sorter: true
//     // },
//     {
//         title: '操作',
//         key: 'action',
//         width: 50,
//         scopedSlots: { customRender: 'action' }
//     }
// ];

export default {
  name: 'WaitMeApply',
  components: {},
  data: function data() {
    return {
      visible: false,
      visibleId: '',
      expand: false,
      formState: {
        summary: '',
        fillId: '',
        formName: undefined,
        timeValue: [],
        category: undefined
      },
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      advanced: false,
      columns: columns,
      dataSource: [],
      selectedRows: [],
      loading: false,
      total: 0,
      pagination: this.$hdk.page(),
      form: {
        pageSize: 10,
        currentNo: 1
      },
      searchVal: {
        beginTime: '',
        endTime: ''
      },
      cateList: []
    };
  },
  authorize: {
    deleteRecord: 'delete'
  },
  methods: {
    //表格行点击事件
    rowClick: function rowClick(record, index) {
      var _this = this;
      return {
        on: {
          dblclick: function dblclick() {
            _this.$router.push({
              path: '/formReview/reviewCenter/auditProcess',
              query: {
                procInsId: record.procInsId,
                taskId: record.taskId,
                path: 'waitMeApplication',
                sinceFillId: record.fillId,
                formName: _this.formState.formName,
                category: _this.formState.category,
                beginTime: _this.formState.timeValue[0],
                endTime: _this.formState.timeValue[1],
                summary: _this.formState.summary,
                fillId: _this.formState.fillId
              }
            });
          }
        }
      };
    },
    handleVisibleChange: function handleVisibleChange(row) {
      // if (row.trackStatus == 2) {
      //     this.visible = true;
      // }
    },
    handlepopConfirmConfirm: function handlepopConfirmConfirm(row) {
      var _this2 = this;
      saveFlowTrack(row).then(function (res) {
        _this2.visible = false;
        _this2.onClicWaitMeApplyList();
      });
    },
    handlepopConfirmCancel: function handlepopConfirmCancel() {
      this.visible = false;
    },
    getForm: function getForm() {
      var _this3 = this;
      getFormCate().then(function (res) {
        // const { data: list } = res.data;
        _this3.cateList = res.data.data;
      });
    },
    cz: function cz() {
      this.$refs.searchFrom.resetFields();
      this.loadData();
    },
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    toggleAdvanced: function toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    pageSizeChange: function pageSizeChange(val, pageNum) {
      this.loading = true;
      this.pagination.pageSize = pageNum;
      this.pagination.current = 1;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = this.pagination.current;
      this.onClicWaitMeApplyList(); //获取列表数据
    },
    pageChange: function pageChange(page, val) {
      this.loading = true;
      this.pagination.current = page;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = this.pagination.current;
      this.onClicWaitMeApplyList(); //获取列表数据
    },
    queryTableList: function queryTableList() {
      this.form.currentNo = 1;
      this.pagination.current = 1;
      this.onClicWaitMeApplyList();
      sessionStorage.removeItem('Pagination_waitMeApplication');
    },
    onClicWaitMeApplyList: function onClicWaitMeApplyList() {
      var _this4 = this;
      var pagination = this.pagination,
        form = this.form,
        pager = _.assign({}, pagination);
      this.loading = true;
      queryWaitMeApplys({
        formName: this.formState.formName,
        category: this.formState.category,
        beginTime: this.formState.timeValue[0],
        endTime: this.formState.timeValue[1],
        summary: this.formState.summary,
        fillId: this.formState.fillId,
        pageSize: pager.pageSize,
        currentNo: pager.current
      }).then(function (res) {
        var data = res.data.data;
        _this4.dataSource = data && Object.prototype.hasOwnProperty.call(data, 'rows') ? data.rows : [];
        _this4.total = data && Object.prototype.hasOwnProperty.call(data, 'total') ? data.total : 0;
        _.assign(pagination, {
          total: _this4.total,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(form, pager.form);
      }).finally(function () {
        _this4.loading = false;
      });
    },
    /*
     * 表格改变事件
     */
    onChangeTable: function onChangeTable(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      sessionStorage.setItem('Pagination_waitMeApplication', JSON.stringify(this.pagination));
      this.onClicWaitMeApplyList();
    },
    loadData: function loadData() {
      this.onClicWaitMeApplyList();
    },
    onViewWaitMeApply: function onViewWaitMeApply(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: record.procInsId
        }
      });
    },
    applyAudit: function applyAudit(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/auditProcess',
        query: {
          procInsId: record.procInsId,
          taskId: record.taskId,
          path: 'waitMeApplication',
          sinceFillId: record.fillId,
          formName: this.formState.formName,
          category: this.formState.category,
          beginTime: this.formState.timeValue[0],
          endTime: this.formState.timeValue[1],
          summary: this.formState.summary,
          fillId: this.formState.fillId
        }
      });
    },
    timeChange: function timeChange(date, dateString) {
      if (date, dateString) {
        this.timeValue = date;
        this.searchVal.beginTime = dateString[0];
        this.searchVal.endTime = dateString[1];
      }
    },
    resetSearchVal: function resetSearchVal() {
      this.timeValue = [];
      this.searchVal = {
        formName: '',
        beginTime: '',
        endTime: ''
      };
      this.loadData();
    },
    toSave: function toSave(row) {
      var _this5 = this;
      this.visibleId = row.processInstanceId || row.procInsId;
      if (row.trackStatus == 2) {
        this.visible = true;
      } else {
        this.visible = false;
        saveFlowTrack(row).then(function (res) {
          _this5.onClicWaitMeApplyList();
        });
      }
    },
    dbTwoClick: function dbTwoClick(row) {
      this.$router.push({
        path: '/formReview/reviewCenter/auditProcess',
        query: {
          procInsId: record.procInsId,
          taskId: record.taskId,
          path: 'waitMeApplication'
        }
      });
      // this.$router.push({
      //     path: '/formReview/reviewCenter/viewProcess',
      //     query: { procInsId: row.procInsId }
      // });
    }
  },
  mounted: function mounted() {
    var savedPagination = sessionStorage.getItem('Pagination_waitMeApplication');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.pagination.current = parsed.current || 1;
        this.pagination.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
    this.loadData();
    this.getForm();
  }
};